// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.panel-title[data-v-c2949920] {\n    margin-left: 7px;\n    margin-top: 5px;\n    margin-bottom: 5px;\n}\ntable[data-v-c2949920] {\n    margin-bottom: 0;\n}\n.total[data-v-c2949920] {\n    font-weight: bold;\n    font-size: 1em;\n}\n.table-td[data-v-c2949920] {\n    width: 30%;\n}\n", ""]);
// Exports
module.exports = exports;
